import { Box, Button, Divider } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import styled from "styled-components";
import {
  SubcontractorTestValue,
  WarehouseTestValue,
} from "../../../operator-subcontractors-add copy/index";
import { StyledButton } from "../../../../../components/Button/button";
import { theme } from "../../../../../helpers/theme";
import { addressAdd } from "../../../../../services/address/add";
import { addSubcontractorToWarehouse } from "../../../../../services/subcontractor/ass-subcontractor-to-warehouse";
import { postSubcontractorAdd } from "../../../../../services/subcontractor/subcontractor-add";
import { postWarehouseAdd } from "../../../../../services/warehouses/warehouse-add";
import { SingleWarehouse } from "../single-warehouse";
import { Subcontractor } from "../subcontractor";
import { warehouseServicesGenerate } from "../../../../../services/warehouse-facilities/warehouse-services-generate";

interface SubcontractorDataAddProps {
  actualInitialSubcontractorAddValue: SubcontractorTestValue;
  actualInitialWarehouseAddValues: WarehouseTestValue;
  addressID: string;
  warehouseAddressID: string;
  subcontractorID: string;
  warehouseID: string;
  warehouseSubcontractorConnection: boolean;
  activeStep: number;

  setAddressID: (value: string) => void;
  setWarehouseAddressID: (value: string) => void;
  setSubcontractorID: (value: string) => void;
  setwarehouseID: (value: string) => void;
  setActiveStep: (value: number) => void;
  setBackToSummary: (value: boolean) => void;
  setWarehouseSubcontractorConnection: (value: boolean) => void;
}

export const SubcontractorSummaryInfo = ({
  actualInitialSubcontractorAddValue,
  actualInitialWarehouseAddValues,
  warehouseSubcontractorConnection,
  addressID,
  warehouseAddressID,
  subcontractorID,
  warehouseID,
  activeStep,
  setActiveStep,
  setWarehouseAddressID,
  setSubcontractorID,
  setBackToSummary,
  setAddressID,
  setwarehouseID,
  setWarehouseSubcontractorConnection,
}: SubcontractorDataAddProps) => {
  const handleEditSubcontractor = () => {
    setActiveStep(0);
    setBackToSummary(true);
  };

  const handleEditWarehous = () => {
    setActiveStep(1);
    setBackToSummary(true);
  };

  ///Subcontractor
  const postNewSubcontractorAddMutation = useMutation(postSubcontractorAdd, {
    onSuccess: (res) => {
      setSubcontractorID(res.data.payload.wykonawca_id);
    },
  });

  const subcontractorAddressAddMutation = useMutation(addressAdd, {
    onSuccess: (res) => {
      setAddressID(res.data.payload.id_klient);

      const subcontractor_data_body = {
        nazwa_wykonawcy: actualInitialSubcontractorAddValue.nazwa_wykonawcy,
        nip: actualInitialSubcontractorAddValue.nip,
        telefon: actualInitialSubcontractorAddValue.telefon,
        email: actualInitialSubcontractorAddValue.email,
        adres_id: res.data.payload.id_klient,
      };
      postNewSubcontractorAddMutation.mutate(subcontractor_data_body);
    },
  });
  ////Warehouse
  const WarehouseServicesGenerateMutation = useMutation(
    warehouseServicesGenerate,
    {}
  );
  const postWarehouseAddMutation = useMutation(postWarehouseAdd, {
    onSuccess: (res) => {
      setwarehouseID(res.data.payload.id_magazyn);
      WarehouseServicesGenerateMutation.mutate({
        id_magazyn: res.data.payload.id_magazyn,
      });
    },
  });

  const warehouseAddressAddMutation = useMutation(addressAdd, {
    onSuccess: (res) => {
      setWarehouseAddressID(res.data.payload.id_klient);

      const warehouse_data_body = {
        kod_magazynu: actualInitialWarehouseAddValues.kod_magazynu,
        opis: actualInitialWarehouseAddValues?.opis
          ? actualInitialWarehouseAddValues.opis
          : null,
        powierzchnia_procentowa:
          actualInitialWarehouseAddValues.powierzchnia_procentowa,
        klasa_magazynu: actualInitialWarehouseAddValues.klasa_magazynu,
        medyczny: actualInitialWarehouseAddValues.medyczny,
        adres_id: res.data.payload.id_klient,
        magazyn_api:
          actualInitialWarehouseAddValues.adres_uslugi === null ||
          actualInitialWarehouseAddValues.adres_uslugi === "" ||
          actualInitialWarehouseAddValues.login === null ||
          actualInitialWarehouseAddValues.login === "" ||
          actualInitialWarehouseAddValues.haslo === null ||
          actualInitialWarehouseAddValues.haslo === ""
            ? null
            : {
                adres_uslugi: actualInitialWarehouseAddValues.adres_uslugi,
                login: actualInitialWarehouseAddValues.login,
                haslo: actualInitialWarehouseAddValues.haslo,
              },
      };
      postWarehouseAddMutation.mutate(warehouse_data_body);
    },
  });

  //Conection
  const addSubcontractorToWarehouseMutation = useMutation(
    addSubcontractorToWarehouse,
    {
      onSuccess: (res) => {
        setWarehouseSubcontractorConnection(true);
        setActiveStep(3);
      },
    }
  );

  useEffect(() => {
    if (subcontractorID !== "no") {
      if (warehouseID !== "no") {
        addSubcontractorToWarehouseMutation.mutate({
          magazyn_id: warehouseID,
          wykonawca_id: subcontractorID,
        });
      }
    }
  }, [subcontractorID, warehouseID]);

  const handleSubmit = () => {
    subcontractorAddressAddMutation.mutate({
      kod_pocztowy: actualInitialSubcontractorAddValue.kod_pocztowy,
      miejscowosc_poczty: actualInitialSubcontractorAddValue.kod_pocztowy,
      miejscowosc: actualInitialSubcontractorAddValue.miejscowosc,
      ulica: actualInitialSubcontractorAddValue?.ulica
        ? actualInitialSubcontractorAddValue.ulica
        : null,
      numer_budynku: actualInitialSubcontractorAddValue.numer_budynku,
      numer_lokalu: actualInitialSubcontractorAddValue?.numer_lokalu
        ? actualInitialSubcontractorAddValue.numer_lokalu
        : null,
      wojewodztwo: actualInitialSubcontractorAddValue.wojewodztwo,
      kraj: actualInitialSubcontractorAddValue.kraj,
    });

    //zapisanie adresu i danych magazynu
    warehouseAddressAddMutation.mutate({
      kod_pocztowy: actualInitialWarehouseAddValues.kod_pocztowy,
      miejscowosc_poczty: actualInitialWarehouseAddValues.kod_pocztowy,
      miejscowosc: actualInitialWarehouseAddValues.miejscowosc,
      ulica: actualInitialWarehouseAddValues?.ulica
        ? actualInitialWarehouseAddValues.ulica
        : null,
      numer_budynku: actualInitialWarehouseAddValues.numer_budynku,
      numer_lokalu: actualInitialWarehouseAddValues?.numer_lokalu
        ? actualInitialWarehouseAddValues.numer_lokalu
        : null,
      wojewodztwo: actualInitialWarehouseAddValues.wojewodztwo,
      kraj: actualInitialWarehouseAddValues.kraj,
    });
  };

  useEffect(() => {}, [activeStep]);

  return (
    <Container>
      <InfoWraper>
        <InfoRow>
          <Title>Podwykonawca</Title>
          <StyledButton
            onClick={handleEditSubcontractor}
            sx={{
              color: `${theme.colors.blue01_active}`,
              height: "30px",
              backgroundColor: `${theme.colors.white}`,
              border: `1px solid ${theme.colors.blue01_active}`,
              marginRight: `32px`,
              "@media(max-width:350px)": {
                width: "100px",
                marginLeft: "32px",
              },
              "&:hover": {
                backgroundColor: `${theme.colors.blue01_active}`,
                color: "white",
              },
            }}
          >
            Edytuj
          </StyledButton>
        </InfoRow>
        <Divider
          sx={{
            margin: "6px 32px",
          }}
        />
        <Subcontractor
          actualInitialSubcontractorAddValue={
            actualInitialSubcontractorAddValue
          }
          addressID={addressID}
          subcontractorID={subcontractorID}
        />
      </InfoWraper>

      <InfoWraper style={{ marginTop: "23px" }}>
        <InfoRow>
          <Title>Magazyn</Title>
          <StyledButton
            onClick={handleEditWarehous}
            sx={{
              color: `${theme.colors.blue01_active}`,
              height: "30px",
              backgroundColor: `${theme.colors.white}`,
              border: `1px solid ${theme.colors.blue01_active}`,
              marginRight: `32px`,
              "@media(max-width:350px)": {
                width: "100px",
                marginLeft: "32px",
              },
              "&:hover": {
                backgroundColor: `${theme.colors.blue01_active}`,
                color: "white",
              },
            }}
          >
            Edytuj
          </StyledButton>
        </InfoRow>
        <Divider
          sx={{
            margin: "6px 32px",
          }}
        />
        <SingleWarehouse
          actualInitialWarehouseAddValues={actualInitialWarehouseAddValues}
          warehouseAddressID={warehouseAddressID}
          warehouseID={warehouseID}
        />
      </InfoWraper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          pt: 2,
        }}
      >
        <Box
          sx={{
            flex: "1 1 auto",
          }}
        />
        <StyledButton
          onClick={() => handleSubmit()}
          sx={{
            width: "100%",
            marginBottom: "64px",
          }}
        >
          Zapisz
        </StyledButton>
      </Box>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  font-family: ${theme.fonts.interMedium};
`;
const Title = styled.div`
  font-family: ${theme.fonts.interMedium};
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 10px;
  font-weight: ${theme.fontWeight.big};
  padding-left: 32px;
  padding-top: 6px;
  padding-right: 32px;
  width: 200px;
`;
const InfoWraper = styled.div`
  background-color: white;
  border-radius: 8px;
`;
const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 32px;
  justify-content: space-between;
  @media (max-width: 350px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;
